import styled from "styled-components";
const ModalContent = styled.div`
  height: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
`;

export default ModalContent;
